module.exports = __webpack_public_path__ + "img/158.fd99f868.png";